export const isObserverSupported = (type) => {
	if (typeof window === "undefined") return false;

	switch (type) {
		case "IntersectionObserver":
			return (
				"IntersectionObserver" in window &&
				typeof window.IntersectionObserver === "function"
			);
		case "ResizeObserver":
			return (
				"ResizeObserver" in window &&
				typeof window.ResizeObserver === "function"
			);
		default:
			return false;
	}
};
